<header id="header-wrap" class="site-header clearfix">
    <div class="top-bar hidden-xs">
        <div class="container">
            <div class="row">
                <div class="col-md-7 col-sm-9 right-top-bar">
                    <ul class="contact-details">
                        <li>
                            <a href="mailto:admin@aldawal.com">
                                <i class="icon-envelope">
                                </i>
                                admin@aldawal.com
                            </a>
                        </li>
                        <li>
                            <a routerLink="/">
                                <i class="icon-call-out">
                                </i>
                                +966-11-4501055
                            </a>
                        </li>
                        <li>
                            <a routerLink="/">
                                <i class="icon-clock">
                                </i>
                                {{'workDays' | translate}} <span class="timing">{{'workTime' | translate}}</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="col-md-5 col-sm-3">
                    <ul class="social-list">
                        <li>
                            <a class="social-link facebook" data-toggle="tooltip" data-placement="bottom"
                                title="Facebook"
                                href="https://www.facebook.com/%D9%85%D8%A4%D8%B3%D8%B3%D8%A9-%D9%86%D8%B8%D9%85-%D8%A7%D9%84%D8%AF%D9%88%D8%A7%D9%84-%D9%84%D8%AA%D9%82%D9%86%D9%8A%D8%A9-%D8%A7%D9%84%D9%85%D8%B9%D9%84%D9%88%D9%85%D8%A7%D8%AA-369043749921264/?ref=bookmarks"><i
                                    class="fa fa-facebook"></i></a>
                        </li>


                        <li>
                            <a class="social-link linkdin" data-toggle="tooltip" data-placement="bottom"
                                title="Linkedin"
                                href="https://www.linkedin.com/company/%D9%85%D8%A4%D8%B3%D8%B3%D8%A9-%D9%86%D8%B8%D9%85-%D8%A7%D9%84%D8%AF%D9%88%D8%A7%D9%84-%D9%84%D8%AA%D9%82%D9%86%D9%8A%D8%A9-%D8%A7%D9%84%D9%85%D8%B9%D9%84%D9%88%D9%85%D8%A7%D8%AA?report%2Esuccess=rRDkPhZQKuByCybw6mUYV5_aI3bIrpgHCx5nFmxDsIDpRwPeBKLcZkcu9Go9rEgtjxVXhrIDyMDwYHgYzhsnS_VJZb"><i
                                    class="fa fa-linkedin"></i></a>
                        </li>
                        <li>
                            <a *ngIf="!dir" class="social-link twitter" data-toggle="tooltip" data-placement="bottom"
                                title="اللغة العربية" (click)="changeLangAR()" style="cursor: pointer;"><i class="fa"
                                    style="font-weight:bold">عربى</i></a>

                            <a *ngIf="dir" class="social-link twitter" data-toggle="tooltip" data-placement="bottom"
                                title="English" (click)="changeLangEN()" style="cursor: pointer;"><i class="fa"
                                    style="font-weight:bold">En</i></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="navbar navbar-default navbar-top" role="navigation" data-spy="affix" data-offset-top="50">
        <div class="container">
            <div class="logo-wrapper">
                <a class="navbar-brand" routerLink="/Home">
                    <img src="../../../assets/images/yellowlogo.png" alt="Aldawal">
                </a>
            </div>
            <div class="navbar-header">


                <div class="slicknav_menu"><span aria-haspopup="true" tabindex="0"
                        class="slicknav_btn slicknav_collapsed shorat" style="outline: none;" (click)="show()"><span
                            class="slicknav_menutxt"></span><span class="slicknav_icon slicknav_no-text"><span
                                class="slicknav_icon-bar"></span><span class="slicknav_icon-bar"></span><span
                                class="slicknav_icon-bar"></span></span></span>
                    <ul class="slicknav_nav slicknav_hidden" aria-hidden="true" role="menu" *ngIf="this.showSubMenu">
                        <li>
                            <a routerLinkActive="active" routerLink="/Home" role="menuitem" tabindex="-1">
                                {{'home' | translate}}
                            </a>

                        </li>

                        <li class="slicknav_collapsed slicknav_parent"><span role="menuitem" aria-haspopup="true"
                                tabindex="-1" class="slicknav_item slicknav_row" style="outline: none;">
                                <a routerLinkActive="active" routerLink="/About" tabindex="-1">
                                    {{'company' | translate}}
                                </a>
                                <span class="slicknav_arrow shorat" (click)="showCom()"><i
                                        class="fa fa-angle-right"></i></span></span>
                            <ul class="dropdown slicknav_hidden" role="menu" aria-hidden="true"
                                *ngIf="this.showComMenu">
                                <li>
                                    <a hrouterLinkActive="active" routerLink="/About" role="menuitem" tabindex="-1">
                                        {{'about' | translate}}
                                    </a>
                                </li>
                                <li>
                                    <a routerLinkActive="active" routerLink="/Articles" role="menuitem" tabindex="-1">
                                        {{ 'articles' | translate }}
                                    </a>
                                </li>

                                <!-- <li>
                                    <a routerLinkActive="active" routerLink="/Careers" role="menuitem" tabindex="-1">
                                        {{'career' | translate}}
                                    </a>
                                </li> -->

                            </ul>
                        </li>

                        <li class="slicknav_collapsed slicknav_parent"><span role="menuitem" aria-haspopup="true"
                            tabindex="-1" class="slicknav_item slicknav_row" style="outline: none;">
                            <a href="#" tabindex="-1">
                                {{'products' | translate}}
                            </a>
                            <span class="slicknav_arrow shorat" (click)="showProduc()"><i
                                    class="fa fa-angle-right"></i></span></span>
                        <ul class="dropdown slicknav_hidden" role="menu" aria-hidden="true"
                            *ngIf="this.showProdMenu">
                            <li><a href="https://www.learnyhome.com/"  role="menuitem"
                                    tabindex="-1"><img style="width:7%"
                                        src="../../../assets/images/leranyhome.png">&nbsp;{{'LearnyhomeTitle'
                                    | translate}}</a> </li>
                            <li><a href="https://fawateerna.com/home" role="menuitem"
                                    tabindex="-1"><img style="width:7%"
                                        src="../../../assets/images/fawateerna.png">&nbsp;{{'fawateernaTitle'
                                    | translate}}</a>
                            </li>
                        </ul>
                    </li>


                        <li class="slicknav_collapsed slicknav_parent"><span role="menuitem" aria-haspopup="true"
                                tabindex="-1" class="slicknav_item slicknav_row" style="outline: none;">
                                <a href="#" tabindex="-1">
                                    {{'e-serv' | translate}}
                                </a>
                                <span class="slicknav_arrow shorat" (click)="showEServ()"><i
                                        class="fa fa-angle-right"></i></span></span>
                            <ul class="dropdown slicknav_hidden" role="menu" aria-hidden="true"
                                *ngIf="this.showServMenu">
                                <li class="slicknav_collapsed slicknav_parent"><span role="menuitem"
                                        aria-haspopup="true" tabindex="-1" class="slicknav_item slicknav_row"
                                        style="outline: none;">
                                        <a href="#" tabindex="-1">
                                            <img style="width:7%" src="../../../assets/images/Metro.png">
                                            {{'metro' | translate}}
                                        </a>
                                        <span class="slicknav_arrow shorat" (click)="showMerto()"><i
                                                class="fa fa-angle-right"></i></span></span>
                                    <ul class="dropdown-submenu slicknav_hidden" role="menu" aria-hidden="true"
                                        *ngIf="this.showMetroMenu">
                                        <li><a href="http://aldawalsys.maps.arcgis.com/apps/View/index.html?appid=e3ffd5d4809a4876a43945490f08fe61"
                                                title="Contractor" role="menuitem" tabindex="-1"><img style="width:7%"
                                                    src="../../../assets/images/1454179655_civil_engineer.ico">&nbsp;{{'contractor'
                                                | translate}}</a>
                                        </li>
                                        <li><a href="http://aldawalsys.maps.arcgis.com/apps/View/index.html?appid=e3ffd5d4809a4876a43945490f08fe61"
                                                title="Sceco" role="menuitem" tabindex="-1"><img style="width:7%"
                                                    src="../../../assets/images/seco.png">&nbsp;{{'sceco' |
                                                translate}}</a> </li>
                                    </ul>
                                </li>
                                <li><a href="https://my.4signing.com/" title="خدمات الشركة" role="menuitem"
                                        tabindex="-1"><img style="width:7%"
                                            src="../../../assets/images/1454179926_Manager.ico">&nbsp;{{'employeeServices'
                                        | translate}}</a> </li>
                                <li><a href="http://conservices.aldawal.com/" title="خدمات المقاولين" role="menuitem"
                                        tabindex="-1"><img style="width:7%"
                                            src="../../../assets/images/1454179655_civil_engineer.ico">&nbsp;{{'clientsServices'
                                        | translate}}</a>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <a routerLinkActive="active" routerLink="/Contact" role="menuitem" tabindex="-1">
                                {{'contact' | translate}}
                            </a>
                        </li>
                    </ul>
                </div>
                <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>


            </div>
            <div class="navbar-collapse collapse">
                <ul class="nav navbar-nav navbar-left">
                    <li>
                        <a routerLinkActive="active" routerLink="/Home">
                            {{'home' | translate}}
                        </a>


                    </li>

                    <li>
                        <a routerLinkActive="active" routerLink="/About">
                            {{'company' | translate}}
                        </a>
                        <ul class="dropdown">
                            <li>
                                <a routerLinkActive="active" routerLink="/About">
                                    {{'about' | translate}}
                                </a>
                            </li>


                            <!-- <li>
                                <a routerLinkActive="active" routerLink="/Team">
                                    {{'team' | translate}}
                                </a>
                            </li> -->
                            <li routerLinkActive="active">
                                <a routerLink="/Articles">
                                    {{ 'articles' | translate }}
                                </a>
                            </li>
                            <!-- <li>
                                <a routerLinkActive="active" routerLink="/Careers">
                                    {{'career' | translate}}
                                </a>
                            </li> -->


                        </ul>
                    </li>

                    <li>
                        <a routerLink="">
                            {{'products' | translate}}
                        </a>
                        <ul class="dropdown">
                            <li>
                                <a href="https://www.learnyhome.com/">
                                    <img style="width:10%" src="../../../assets/images/leranyhome.png">
                                    {{'LearnyhomeTitle' | translate}}
                                </a>
                            </li>
                            <li>
                                <a href="https://fawateerna.com/home" >
                                    <img style="width:10%" src="../../../assets/images/fawateerna.png">&nbsp;{{'fawateernaTitle' | translate}}
                                </a> 
                            </li>

                            <li>
                                <a href="https://4signing.com/#/home" >
                                    <img style="width:10%" src="../../../assets/images/4sign.png">&nbsp;{{'4sigingTitle' | translate}}
                                </a> 
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a routerLink="">
                            {{'e-serv' | translate}}
                        </a>
                        <ul class="dropdown">
                            <li>
                                <a routerLink="/">
                                    <img style="width:10%" src="../../../assets/images/Metro.png">
                                    {{'metro' | translate}}
                                </a>
                                <ul class="dropdown-submenu">
                                    <li><a href="https://www.arcgis.com/home/item.html?id=5077d4de24e948c0bf97a30b8e30abfd"
                                            title="Contractor"><img style="width:10%"
                                                src="../../../assets/images/1454179655_civil_engineer.ico">&nbsp;{{'contractor'
                                            | translate}}</a>
                                    </li>
                                    <li><a href="https://dawal.maps.arcgis.com/apps/MapTools/index.html?appid=0756f789229f4ef987574e33c5ed802a"
                                            title="Sceco"><img style="width:10%"
                                                src="../../../assets/images/seco.png">&nbsp;{{'sceco' | translate}}</a>
                                    </li>
                                </ul>
                            </li>
                            <li><a href="https://my.4signing.com/authentication/signin" title="خدمات الشركة"><img style="width:10%"
                                        src="../../../assets/images/1454179926_Manager.ico">&nbsp;{{'employeeServices' |
                                    translate}}</a> </li>
                            <li><a href="http://conservices.aldawal.com/" title="خدمات المقاولين"><img style="width:10%"
                                        src="../../../assets/images/1454179655_civil_engineer.ico">&nbsp;{{'clientsServices'
                                    | translate}}</a> </li>
                        </ul>
                    </li>
                    <li>
                        <a routerLinkActive="active" routerLink="/Contact">
                            {{'contact' | translate}}
                        </a>
                    </li>
                    <li>
                        <a href="https://applicationform.aldawal.com/Applications/Create" target="_blank">
                            {{'Careers' | translate}}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</header>